import ApiSistema from '@/core/apis/ApiSistema';
import { IDadosLogin } from '@/core/models/IDadosLogin';
import { IResposta } from '@/core/models/IResposta';
import { IRespostaArquivo } from '@/core/models/IRespostaArquivo';
import { IRetornoAutenticacao } from '@/core/models/IRetornoAutenticacao';
import { IRetornoConsultaCNPJ } from '@/core/models/IRetornoConsultaCNPJ';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IDTOFichaJagua } from '@/models/DTO/IDTOFichaJagua';
import { IDTOUsuarioMeusDados } from '@/models/DTO/Usuarios/IDTOUsuarioMeusDados';
import { IConfiguracao } from '@/models/Entidades/IConfiguracao';
import { IParceiro } from '@/models/Entidades/IParceiro';
import { IUsuario } from '@/models/Entidades/IUsuario';
import { ETipoNotificacaoEmail } from '@/models/Enumeradores/ETipoNotificacaoEmail';

class ServicoApp {
    private endPoint = 'app';

    private apiSistema = new ApiSistema();

    public async consultaCnpj(cnpj:string, dadosAtualizados = false): Promise<IRetornoConsultaCNPJ> {
      const result: any = await this.apiSistema.getTokenComunicacao(`utilitarios/consultas/cnpj/${cnpj}?dadosAtualizados=${dadosAtualizados}`);
      return result.data;
    }

    public async obterDataAtual(): Promise<string> {
      const result: any = await this.apiSistema.get(`${this.endPoint}/data-atual`);
      return result.data;
    }

    public async enviarVarios(arquivos: any[]): Promise<IRespostaArquivo[]> {
      const data = new FormData();
      for (let i = 0; i < arquivos.length; (i += 1)) {
        data.append('arquivos', arquivos[i]);
      }

      const result: any = await this.apiSistema.upload(`${this.endPoint}/arquivos/upload/varios`, data);
      return result.data;
    }

    public async login(dadosLogin: IDadosLogin): Promise<IRetornoAutenticacao> {
      const result: any = await this.apiSistema.post('autenticacao/login', dadosLogin);
      return result.data;
    }

    public async fichaCadastro(dados: IDTOFichaJagua): Promise<IRetornoRelatorio> {
      const result: any = await this.apiSistema.post('autenticacao/ficha/cadastro', dados);
      return result.data;
    }

    public async obterDadosUsuarioAutenticado(): Promise<IUsuario> {
      const result: any = await this.apiSistema.get('autenticacao/dados');
      return result.data;
    }

    public async atualizarDadosUsuarioAutenticado(meusDados: IDTOUsuarioMeusDados): Promise<IResposta> {
      const result: any = await this.apiSistema.put('autenticacao/dados', meusDados);
      return result.data;
    }

    public async atualizarToken(): Promise<IRetornoAutenticacao> {
      const result: any = await this.apiSistema.post('autenticacao/atualizar-token');
      return result.data;
    }

    public async deslogar(): Promise<IRetornoAutenticacao> {
      const result: any = await this.apiSistema.post('autenticacao/logout');
      return result.data;
    }

    public async obterConfiguracoes(): Promise<IConfiguracao> {
      const result: any = await this.apiSistema.get('configuracoes');
      return result.data;
    }

    public async atualizarConfiguracoes(configuracoes: IConfiguracao): Promise<IResposta> {
      const result: any = await this.apiSistema.put('configuracoes', configuracoes);
      return result.data;
    }

    public async atualizarConfiguracoesEmails(configuracoes: IConfiguracao): Promise<IResposta> {
      const result: any = await this.apiSistema.put('configuracoes/emails', configuracoes);
      return result.data;
    }

    public async obterDadosMeuNegocio(): Promise<IParceiro> {
      const result: any = await this.apiSistema.get('meu-negocio');
      return result.data;
    }

    public async atualizarDadosMeuNegocio(parceiro: IParceiro): Promise<IResposta> {
      const result: any = await this.apiSistema.put('meu-negocio', parceiro);
      return result.data;
    }

    public obterDescricaoTipoNotificacaoEmail(tipoNotificacao:ETipoNotificacaoEmail):string {
      let descricao = '';
      switch (tipoNotificacao) {
        case ETipoNotificacaoEmail.Padrao:
          descricao = 'Padrão';
          break;

        case ETipoNotificacaoEmail.NovaReserva:
          descricao = 'Nova Reserva';
          break;

        case ETipoNotificacaoEmail.ReservaConfirmada:
          descricao = 'Reserva Confirmada';
          break;

        case ETipoNotificacaoEmail.ReservaCancelada:
          descricao = 'Reserva Cancelada';
          break;

        default:
          break;
      }
      return descricao;
    }

    public obterDestintariosTipoNotificacaoEmail(tipoNotificacao:ETipoNotificacaoEmail, destinatarios:string):string {
      let descricaoDestinatarios = '';
      switch (tipoNotificacao) {
        case ETipoNotificacaoEmail.Padrao:
        case ETipoNotificacaoEmail.NovaReserva:
        case ETipoNotificacaoEmail.ReservaCancelada:
        case ETipoNotificacaoEmail.ReservaConfirmada:
          descricaoDestinatarios = 'Candidatos e Administradores';
          break;

        default:
          break;
      }
      return descricaoDestinatarios;
    }

    public preencherDestintariosTipoNotificacaoEmail(tipoNotificacao:ETipoNotificacaoEmail):boolean {
      let preencher = false;
      switch (tipoNotificacao) {
        case ETipoNotificacaoEmail.Padrao:
        case ETipoNotificacaoEmail.NovaReserva:
        case ETipoNotificacaoEmail.ReservaCancelada:
        case ETipoNotificacaoEmail.ReservaConfirmada:
          preencher = true;
          break;

        default:
          break;
      }
      return preencher;
    }
}
export default ServicoApp;
